module.exports = __webpack_public_path__ + "static/img/hoverlogo03.d492bfac.png";